module.exports = __webpack_public_path__ + "img/logo-white.12ccae2b.png";